var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{attrs:{"src":require("../assets/image/all/logo.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }